import(/* webpackMode: "eager", webpackExports: ["FeedbackAlert"] */ "/app/apps/web/src/app/[locale]/(space)/(dashboard)/feedback-alert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CreatePageIcon","PollPageIcon","EventPageIcon","ProfilePageIcon","PreferencesPageIcon","BillingPageIcon"] */ "/app/apps/web/src/app/components/page-icons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContainer","PageHeader","PageTitle","PageContent"] */ "/app/apps/web/src/app/components/page-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Trans"] */ "/app/apps/web/src/components/trans.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.3.1_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-_2336ead6c9af193fdc07ef65fb435775/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TileGrid","Tile","TileTitle","TileDescription"] */ "/app/packages/ui/src/tile.tsx");
